<div class="container-right-main fluid-container">
    <app-feedback-header [title]="'Roleplay Feedback Details'" [buttonText]="'Roleplay Details'"
        [headerData]="headerData" (backClick)="goBack()" (showConversationClick)="viewFeedbackDetails()"
        (assignClick)="openAssignTicketToDialog()">
    </app-feedback-header>

    <app-feedback-comment-timeline #timelineRef [isFileUploadEnabled]="true" [feedbackId]="feedbackId"
        [downloadContext]="'roleplayFeedback'" [historyDetails]="historyDetails" [feedbackStatusList]="statusList"
        [selectedFeedbackStatus]="selectedStatus" [commentText]="commentText" [isSubmitting]="isSubmitting"
        [isLoading]="isLoading" (statusChange)="onStatusChange($event)" (submitComment)="addComment()"
        (commentTextChange)="commentText = $event" (filesChanged)="onFilesChanged($event)">
    </app-feedback-comment-timeline>
</div>